import { ApiErrorCodes, ApiResponseException } from '@btcdirect/shared/src/composables/api/types';
import { contains } from '@btcdirect/shared/src/composables/util/array';

/**
 * Create an exception in a format we expect so we can catch them correctly
 * @param message
 * @param code
 * @param status
 */
export function createException(message: string, code: string = ApiErrorCodes.ER999, status: number = 500): ApiResponseException {
    return {
        status: status,
        data: {
            errors: {
                [code]: {
                    code: code,
                    message: message
                }
            }
        }
    } as ApiResponseException;
}

/**
 * Check if the exception contains the specified error code(s)
 * @param codes
 * @param exception
 */
export function hasErrorCode(codes: string | string[], exception: ApiResponseException) {
    const errors = getErrorCodes(exception);

    return contains(codes, errors);
}

function getErrorCodes(exception: ApiResponseException): string[] {
    if (!exception.data?.errors) {
        return [];
    }

    return Object.keys(exception.data.errors);
}
